//Componentes generales
import React, { useContext, useReducer } from "react";
import subcuentasReducer from "./subcuentasReducer";
import subcuentasContext from "./subcuentasContext";

//Socket
import { SocketContext } from "../socket/socket";

//Axios
import clienteAxios from "../../config/axios";

//Rutas de api
import { getDimensiones, getSubcuentas, uploadSubcuenta } from "../../api/subcuenta"

//Acciones
import { 
    ACTUALIZAR_DIMENSIONES,
    ACTUALIZAR_SUBCUENTAS,
    ACTUALIZAR_SUBCUENTAS_DB,
    CARGANDO_SUBCUE,
    ERROR_SUBCUE,
    LIMPIAR_ERROR
} from "./subcuentasActions";

/* 
    State encargado de la gestión de subcuentas.
*/
const SubcuentasState = props => {

    const server = useContext(SocketContext);

    //Valores iniciales
    const initialState = {
        dimensiones: [],
        subcuentas: [],
        // Arranca en true: todavía no se hizo la carga inicial, evita mostrar
        // "No hay registros" antes de que llegue la respuesta del servidor.
        cargando: true,
        error: ""
    };

    const [state, dispatch] = useReducer(subcuentasReducer, initialState);

    /* 
        Función recuperar los subcuentas y a su vez actualizarlas.
    */
    const actualizarSubcuentas = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR SUBCUENTAS");
            const resp = await getSubcuentas();
            dispatch({
                type: ACTUALIZAR_SUBCUENTAS,
                payload: resp.data.data
            })
            console.log("RESPUESTA DE SUBCUENTAS SQL",resp)
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

        const actualizarDimensiones = async () => {

        try{
            console.log("ENTRO AL ACTUALIZAR DIMENSIONES");
            const resp = await getDimensiones();
            dispatch({
                type: ACTUALIZAR_DIMENSIONES,
                payload: resp.data.data
            })
            console.log("RESPUESTA DE DIMENSIONES",resp)
            return resp.data.data;

        }catch(error){
            console.log(error);
        }
    }

    /* 
        Función encargada de sobreescribir la tabla de subcuentas con la propia de Softland.
            Donde userID es el ID del usuario en sesión.
                  userName es el nombre del usuario en sesión.
    */
    const actualizarSubcuentasDB = async (userID, userName) => {

        try{
            console.log("ENTRO AL ACTUALIZAR SUBCUENTAS DB");
            // El endpoint solo confirma que el proceso arrancó en segundo plano;
            // hay que esperar el aviso por socket para saber el resultado real.
            await uploadSubcuenta(userID, userName);

            if (!server) {
                throw new Error("No hay conexión en tiempo real disponible. Recargue la página e intente nuevamente.");
            }

            const resultado = await new Promise((resolve) => {
                server.once("actualizarSubcuentasFinalizado", resolve);
            });

            if (resultado.status !== 200) {
                dispatch({
                    type: ERROR_SUBCUE,
                    payload: resultado.message
                });
                return {status: false, msg: resultado.message};
            }

            const resp = await getSubcuentas();
            dispatch({
                type: ACTUALIZAR_SUBCUENTAS_DB,
                payload: resp.data.data
            });
            console.log("RESPUESTA DE SUBCUENTAS MONGO",resp)
        return {status: true, msg: "Se actualizo con exito la base de datos."};

        }catch(error){
            console.log(error);
            const errMsg = error?.response?.data?.errMsg || error.message;
            dispatch({
                type: ERROR_SUBCUE,
                payload: errMsg
            });

            return {status: false, msg: errMsg};
        }
    }

    const cargando =  () => {
        dispatch({
            type: CARGANDO_SUBCUE
        })
    }

    const limpiarError = () => {
        dispatch({
            type: LIMPIAR_ERROR
        })
    }

    return(
        <subcuentasContext.Provider
            value={{
                dimensiones: state.dimensiones,
                subcuentas: state.subcuentas,
                isCargando: state.cargando,
                error: state.error,
                actualizarSubcuentas,
                actualizarDimensiones,
                actualizarSubcuentasDB,
                cargando,
                limpiarError
            }}
        >

            {props.children}

        </subcuentasContext.Provider>
    )
    
}

export default SubcuentasState;